import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { TransactionListActionsCell } from './transaction-list-actions.cell';
import { TransactionListActionsHeader } from './transaction-list-actions.header';

export const TransactionListActionsColumn: DisplayColumnDef<
  TransactionModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: TransactionListActionsHeader,
  cell: TransactionListActionsCell,
  meta: { maxWidth: '90px', width: '85px' },
};
